import api from './client';

class NotificationsAPI {
  static async list(params = {}) {
    const response = await api.get('/notifications', { params });
    return response.data.data;
  }

  static async count() {
    const response = await api.get('/notifications/count');
    return response.data.data;
  }

  static async markRead(id) {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data.data;
  }

  static async markReadAll() {
    const response = await api.patch('/notifications/read-all', {});
    return response.data.data;
  }

  static async remove(id) {
    const response = await api.delete(`/notifications/${id}`);
    return response.data.data;
  }

  static async clearAll() {
    const response = await api.delete('/notifications/clear-all');
    return response.data.data;
  }

  static async dispatch(payload) {
    const response = await api.post('/notifications/dispatch', payload);
    return response.data.data;
  }

  static async dispatchBulk(payload) {
    const response = await api.post('/notifications/dispatch/bulk', payload);
    return response.data.data;
  }

  static async dispatchRole(payload) {
    const response = await api.post('/notifications/dispatch/role', payload);
    return response.data.data;
  }

  static async preferences() {
    const response = await api.get('/notifications/preferences');
    return response.data.data;
  }

  static async patchPreferences(payload) {
    const response = await api.patch('/notifications/preferences', payload);
    return response.data.data;
  }

  static async patchEventPreference(eventType, payload) {
    const response = await api.patch(`/notifications/preferences/${encodeURIComponent(eventType)}`, payload);
    return response.data.data;
  }

  static async enableDnd(payload) {
    const response = await api.post('/notifications/dnd', payload);
    return response.data.data;
  }

  static async dndStatus() {
    const response = await api.get('/notifications/dnd/status');
    return response.data.data;
  }

  static async watch(payload) {
    const response = await api.post('/notifications/watch', payload);
    return response.data.data;
  }

  static async unwatch(payload) {
    const response = await api.delete('/notifications/unwatch', { data: payload });
    return response.data.data;
  }

  static async watching() {
    const response = await api.get('/notifications/watching');
    return response.data.data;
  }

  static async pendingDigests() {
    const response = await api.get('/notifications/digests/pending');
    return response.data.data;
  }

  static async releaseDigests(payload) {
    const response = await api.post('/notifications/digests/release', payload);
    return response.data.data;
  }

  static async patchAggregationRules(payload) {
    const response = await api.patch('/notifications/config/aggregation-rules', payload);
    return response.data.data;
  }

  static async createBroadcast(payload) {
    const response = await api.post('/admin/notifications/broadcast', payload);
    return response.data.data;
  }

  static async activeBroadcasts() {
    const response = await api.get('/admin/notifications/broadcasts/active');
    return response.data.data;
  }

  static async expireBroadcast(id) {
    const response = await api.patch(`/admin/notifications/broadcasts/${id}/expire`, {});
    return response.data.data;
  }

  static async mappings() {
    const response = await api.get('/sys/notifications/mappings');
    return response.data.data;
  }

  static async createMapping(payload) {
    const response = await api.post('/sys/notifications/mappings', payload);
    return response.data.data;
  }

  static async updateMapping(event, payload) {
    const response = await api.put(`/sys/notifications/mappings/${encodeURIComponent(event)}`, payload);
    return response.data.data;
  }

  static async stats() {
    const response = await api.get('/admin/notifications/stats');
    return response.data.data;
  }

  static async logs(params = {}) {
    const response = await api.get('/admin/notifications/logs', { params });
    return response.data.data;
  }

  static async deliveryFailures() {
    const response = await api.get('/admin/notifications/delivery-failures');
    return response.data.data;
  }

  // --- Browser Web Push ---

  // Returns { enabled, publicKey } — publicKey only present when push is
  // configured server-side (VAPID keys set).
  static async pushVapidKey() {
    const response = await api.get('/notifications/push/vapid-public-key');
    return response.data.data;
  }

  // `sub` is a PushSubscription JSON ({ endpoint, keys: { p256dh, auth } }).
  static async pushSubscribe(sub, userAgent) {
    const payload = { ...sub };
    if (userAgent) payload.userAgent = userAgent;
    const response = await api.post('/notifications/push/subscribe', payload);
    return response.data.data;
  }

  static async pushUnsubscribe(endpoint) {
    const response = await api.post('/notifications/push/unsubscribe', { endpoint });
    return response.data.data;
  }
}

export { NotificationsAPI as notifications };
